import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { resetCarriers } from './carriersSlice';
import { resetDashboard } from './dashboardSlice';

const initialState = {
  user: {},
  userRole: "",
  loading: false,
  error: null,
};

export const signInUser = createAsyncThunk(
  'signInUser/signInUser',
  async (data, { rejectWithValue }) => {
  try {
    const { email, password } = data || {};
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/sign-in`, {
    email,
    password,
    }, {
      headers: {
          'Content-Type': 'application/json',
      }
    });
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const signOutUser = () => (dispatch) => {
  try {
    dispatch(userSlice.actions.resetUser());
    dispatch(resetCarriers());
    dispatch(resetDashboard());
  } catch (error) {
    console.error('Failed to sign out:', error);
  }
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
     resetUser: (state) => {
      state.user = {};
      state.userRole = "";
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signInUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.userRole = action.payload.role;
        state.error = null;
      })
      .addCase(signInUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Login failed";
      });
  },
});

export const { resetUser } = userSlice.actions;
export default userSlice.reducer;
